import { render, staticRenderFns } from "./back-money.pug?vue&type=template&id=320c7941&lang=pug&"
import script from "./back-money.ts?vue&type=script&lang=ts&"
export * from "./back-money.ts?vue&type=script&lang=ts&"
import style0 from "./back-money.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports